import axios from 'axios';
import { auth } from '../lib/firebase';
import { safeStorage } from '../utils/storage';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to add the auth token
api.interceptors.request.use(async (config) => {
  try {
    // Get the current user
    const user = auth.currentUser;
    if (user) {
      // Use getToken from AuthContext instead of directly calling getIdToken
      const token = await user.getIdToken(false); // false means don't force refresh
      config.headers['Authorization'] = `Bearer ${token}`;
      config.headers['Accept-Language'] = safeStorage.get('preferredLanguage') || 'en';
    }

    // Add store ID if available
    const selectedStoreId = safeStorage.get('selectedStoreId');
    if (selectedStoreId) {
      config.headers['Store-Id'] = String(selectedStoreId);
    }

    return config;
  } catch (error) {
    console.error('Error in axios interceptor:', error);
    return Promise.reject(error);
  }
}, (error) => {
  return Promise.reject(error);
});

// Add a function to set up the response interceptor with notification capability
export const setupAxiosErrorHandler = (t, showNotification) => {
  // Response interceptor for API errors
  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Only show notification if the function was provided. A request made
      // with `silent: true` handles its own failure (e.g. a lookup with a
      // fallback), so a toast for it would report an error that never surfaced.
      if (showNotification && !error.config?.silent) {
        // Get error details
        // const status = error.response?.status;
        let message = error.response?.data?.errors || error.response?.data?.error;
        let title = t('common.backendError.single');
        
        if (Array.isArray(message)) {
          message = '<ul class="list-disc list-inside">' + message.map(msg => `<li>${msg}</li>`).join('') + '</ul>';
          title = t('common.backendError.multiple');
        }
        
        // Set appropriate title based on status code
        // if (status === 401) {
        //   title = 'Authentication Error';
        // } else if (status === 403) {
        //   title = 'Permission Denied';
        // } else if (status === 404) {
        //   title = 'Not Found';
        // } else if (status >= 500) {
        //   title = 'Server Error';
        // }
        
        // Show notification
        showNotification(title, message, 'error');
      }
      
      // Return the error to be handled by the calling code if needed
      return Promise.reject(error);
    }
  );
};

export default api; 